import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from "./store";
import "./styles/common.scss";

Vue.config.productionTip = false
Vue.use(ElementUI);


// 修改 el-dialog 的默认属性
ElementUI.Dialog.props.closeOnClickModal.default = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
